import React, { useEffect, useState } from "react";
import "./Toast.css";

const ICONS = {
  success: "✓",
  error: "✕",
  info: "ℹ",
};

const TITLES = {
  success: "Success",
  error: "Error",
  info: "Info",
};

export default function Toast({ open, message, type = "info", duration = 3000, onClose }) {
  const [hiding, setHiding] = useState(false);

  useEffect(() => {
    if (!open) return;
    setHiding(false);
    const hideTimer = setTimeout(() => {
      setHiding(true);
    }, duration - 300);
    const closeTimer = setTimeout(() => {
      onClose && onClose();
    }, duration);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(closeTimer);
    };
  }, [open, duration, onClose]);

  const handleClose = () => {
    setHiding(true);
    setTimeout(() => onClose && onClose(), 250);
  };

  if (!open) return null;

  return (
    <div className="toast-wrapper" role="alert" aria-live="assertive">
      <div className={`toast-box toast-${type}${hiding ? " toast-hiding" : ""}`}>
        {/* Icon */}
        <div className="toast-icon">{ICONS[type] || ICONS.info}</div>

        {/* Body */}
        <div className="toast-body">
          <span className="toast-title">{TITLES[type] || "Notification"}</span>
          <span className="toast-message">{message}</span>
        </div>

        {/* Close */}
        <button className="toast-close" onClick={handleClose} aria-label="Close">✕</button>

        {/* Progress bar */}
        <div
          className="toast-progress"
          style={{ animationDuration: `${duration}ms` }}
        />
      </div>
    </div>
  );
}
